// src/stats/StatsPage.tsx
import { Suspense, lazy } from 'react'

const StatsPageInner = lazy(() =>
  import('./StatsPageInner').then((m) => ({ default: m.StatsPageInner })),
)

export function StatsPage() {
  return (
    <Suspense
      fallback={
        <div style={{ padding: '2rem', color: 'var(--muted)', fontSize: '0.875rem' }}>
          Chargement des stats…
        </div>
      }
    >
      <StatsPageInner />
    </Suspense>
  )
}
